import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=b1e1385c&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=ts"
export * from "./EventEdit.vue?vue&type=script&lang=ts"
import style0 from "./EventEdit.vue?vue&type=style&index=0&id=b1e1385c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e1385c",
  null
  
)

export default component.exports